import React, { useEffect, useState } from "react";
import Header from "../Component/Header";
/* import { getCircular } from "../Service/Api"; */
import { Link } from 'react-router-dom'; 
const TenderNotice = () => {
    useEffect(() => {
        document.title = 'Tender Notice -  The Air Force School Subroto Park';  
    }, []);  
/*     const [recruitmentData, setRecruitmentData] = useState([]);

    useEffect(() => {
      const fetchData = async () => {
        try {
          
          const cirData1 = await getCircular();
           const cirData = cirData1.filter((item) =>  item.category === "Tender" ); 
            cirData.sort((a,b) => new Date(b.fromDate) - new Date(a.fromDate)); 
          setRecruitmentData(cirData || []);
        } catch (error) {
          console.error("Failed to fetch news:", error); 
          setRecruitmentData([]);
        }
      };
      fetchData();
    }, []);
    const emptyArray = [
        { },
    ]; */
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                
                 <li>Tender Notice</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Tender Notice </h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                       <ul className="list tender"> 
                          <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/RFP-Renovation-of-Jr-Wing Washroom.pdf" target="_blank"> RENOVATION OF JUNIOR WING STUDENTS WASHROOM  <p>Last date and time for depositing the bids: 13 May 2025, 1100 hrs  <span> View More </span></p> </Link>  </li>
                          <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/tender-rate-contract-stationery.pdf" target="_blank"> RATE CONTRACT FOR SUPPLY OF STATIONERY ITEMS AT THE AIR FORCE SCHOOL & AIR FORCE GOLDEN JUBILEE INSTITUTE, SUBROTO PARK  <p>Last date and time for depositing the bids: 14 May 2025, 1100 hrs  <span> View More </span></p> </Link>  </li>
                         <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/BoardingHouse.pdf" target="_blank"> Laundry Services : Boarding House, The Air Force School, Subroto Park, New Delhi 110 010 <p> Last Date and Time for Depositing the Bids: 03 Apr 2025, 1100 hrs  <span> View More </span></p> </Link>  </li>
                         <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/football-hockey.pdf" target="_blank">development of football / hockey ground into multi use games area (muga) at the air force school     <span> View More </span>  </Link>  </li>
                         <li><Link to="https://docs.google.com/forms/d/e/1FAIpQLSde0hEu9MFZJPWTvyFIQpdPg7UWafWxsLwz8HKDopaGGQpCuQ/viewform" target="_blank"> request for registration of firm for supply / services    <span> View More </span>  </Link>  </li>
                       </ul>  
                      
                      {  /*  {recruitmentData.length > 0 ? (
                         recruitmentData.map((item, index) => (
                           <ul className="list tender recruitment"> 
                               <li key={index}>  
                                 <div className="recruitmentbox">
                                       <div dangerouslySetInnerHTML={{ __html: item.title }} />  
                                       <div dangerouslySetInnerHTML={{ __html: item.description }} /> 
                                 </div>
                                <div className="multiatttch">
                                   {item.attachments?.[0] && (
                                     item.attachments.map((attch,index) =>   ( 
                                       <Link key={index}
                                       to={`https://webapi.entab.info/api/image/${attch}`}
                                       target="_blank"
                                       rel="noopener noreferrer"
                                     >
                                        Click Here
                                     </Link>
                                     )  
                                     )  
                               )}
                              </div></li>
                           </ul>
                         ))
                       ) : (
                         <p></p>
                       )}  */}

                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default TenderNotice
